<div class="container">
  <h1>{{ lesson?.title }}</h1>
  <div class="editor">
    @for(item of items; track item.id) {

    <!-- text -->
    @if(item.type === 'text') {
    <!-- <div class="box">
      @for(i of item.items; track i.id) {
      <div
        class="text"
        *ngIf="i?.heading"
        [innerHTML]="i?.heading"
        [froalaEditor]="froalaEditorOptions"
      ></div>
      <div
        class="text"
        *ngIf="i?.paragraph"
        [innerHTML]="i?.paragraph"
        [froalaEditor]="froalaEditorOptions"
      ></div>
      }
    </div> -->
    }
    <!-- /text -->

    <!-- divider -->
    @if(item.type === "divider") {

    <div class="divider {{ item.variant }}"></div>
    }
    <!-- /divider -->

    <!-- multimedia -->
    @if(item.type === "multimedia") {
    <div class="multimedia box">
      <nb-icon icon="film-outline"></nb-icon>
    </div>
    }
    <!-- /multimedia -->

    <!-- image -->
    @if(item.type === "image") {
    <div class="image box">
      <nb-icon icon="image-outline"></nb-icon>
    </div>
    }
    <!-- /image -->

    }
  </div>
</div>
